/* global axios */
import ApiClient from './ApiClient';

class BroadcastsAPI extends ApiClient {
  constructor() {
    super('broadcasts', { accountScoped: true });
  }

  async list({ status = null, q = null, limit = 50, offset = 0 } = {}) {
    const params = { limit, offset };
    if (status) params.status = status;
    if (q) params.q = q;
    return axios.get(this.url, { params });
  }

  async show(id) {
    return axios.get(`${this.url}/${id}`);
  }

  async create(broadcastData) {
    return axios.post(this.url, { broadcast: broadcastData });
  }

  async update(id, broadcastData) {
    return axios.patch(`${this.url}/${id}`, { broadcast: broadcastData });
  }

  async delete(id) {
    return axios.delete(`${this.url}/${id}`);
  }

  async duplicate(id) {
    return axios.post(`${this.url}/${id}/duplicate`);
  }

  async pause(id) {
    return axios.post(`${this.url}/${id}/pause`);
  }

  async resume(id) {
    return axios.post(`${this.url}/${id}/resume`);
  }

  async cancel(id) {
    return axios.post(`${this.url}/${id}/cancel`);
  }

  async contacts(id, { status = null, q = null, limit = 50, offset = 0 } = {}) {
    const params = { limit, offset };
    if (status) params.status = status;
    if (q) params.q = q;
    return axios.get(`${this.url}/${id}/contacts`, { params });
  }

  async csvPreview(csvContent) {
    return axios.post(`${this.url}/csv_preview`, { csv_content: csvContent });
  }

  async contactsPreview({ sourceType, sourceConfig }) {
    return axios.post(`${this.url}/contacts_preview`, {
      source_type: sourceType,
      source_config: sourceConfig,
    });
  }

  async exportCsv(id) {
    return axios.get(`${this.url}/${id}/export`, { responseType: 'blob' });
  }
}

export default new BroadcastsAPI();
